'use client';
import React, { useState, useEffect } from 'react';
import useCustomSWR from '@/hook/useCustomSWR';
import { useInView } from 'react-intersection-observer';
import Card from '@/components/product/Card';
import { v4 as uuidv4 } from 'uuid';
const SubProduct = ({ id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView, entry } = useInView({
    /* Optional options */
    triggerOnce: true,
    rootMargin: '500px 0px',
    threshold: 0,
  });

  useEffect(() => {
    if (!inView) return;
    setIsVisible(true);
  }, [inView]);

  const { data, isLoading, isError, revalidate } = useCustomSWR(
    `/v1/products/get-all-products?filter[sub_category_id][$eq]=${id}&page=1&limit=4&random=yes`,
    inView
  );
  if (!isVisible) return <div ref={ref}></div>;
  return (
    <div
      ref={ref}
      className='grid w-full grid-cols-2 gap-2 p-5 md:grid-cols-3 md:gap-5 lg:grid-cols-4'
    >
      {data?.productList?.map((product, i) => (
        <Card key={i} product={product} />
      ))}
    </div>
  );
};

export default SubProduct;
